// Property Management Permissions

export const PROPERTIES_INDEX = 13;
export const PROPERTIES_SHOW = PROPERTIES_INDEX;
export const PROPERTIES_CREATE = 14;
export const PROPERTIES_EDIT = 15;
export const PROPERTIES_DELETE = 16;

// Property Detail Views
export const PROPERTIES_VIEW_CONTRACTS = 123;
export const PROPERTIES_VIEW_INVOICES = 124;
// The dues endpoint gates on units.view_dues (119) — there is no properties-side dues key.
export const PROPERTIES_VIEW_DUES = 119;
export const PROPERTIES_VIEW_TIMELINE = 126;
// The tab lists units, so it follows units.index (17); no properties-side units endpoint exists.
export const PROPERTIES_VIEW_UNITS = 17;

export const PROPERTIES_RESTORE = 1376;

// Smart Reports tab. Two keys, not one: the catalogue reports what every unit of
// the property was billed and still owes, which is a wider read than the property
// record, and printing the document that leaves the office is its own privilege.
//
// The numbers are the approval numbers the central key registry issued for
// `properties.smart_reports` and `properties.smart_reports_print` — not the next
// local ids, which is why they skip 1512-1514.
export const PROPERTIES_SMART_REPORTS = 1515;
export const PROPERTIES_SMART_REPORTS_PRINT = 1516;
